import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * "Minhas Atividades" (todo usuário) e "Auditoria de Usuários" (suporte) são a MESMA tela em duas
 * rotas. São duas porque o título (<h1>, trilha e aba do navegador) sai da `description` da rota:
 * um nome só não serviria aos dois públicos. A tela decide o modo pelo nome da rota e confere no
 * servidor — quem não é suporte e abre a rota de auditoria é levado para a de "Minhas Atividades".
 *
 * Sem permissão de tela de propósito (como "Meus Arquivos"): é do menu da CONTA e todo usuário
 * logado tem direito a ver a própria atividade. A trava de quem vê o quê é do servidor
 * (AtividadesUsuarioServico). Ver docs/atividades-usuario/README.md.
 */
export default [
  {
    description: 'Minhas Atividades',
    path: '/ferramentas/minhas_atividades',
    name: 'minhas_atividades',
    component: () => import('@/views/ferramentas/atividadesusuario/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.FERRAMENTAS_GESTAO_ATIVIDADES_MENU_2500700100],
    },
    goesToMenu: true,
  },
  {
    description: 'Auditoria de Usuários',
    path: '/ferramentas/auditoria_usuarios',
    name: 'auditoria_usuarios',
    component: () => import('@/views/ferramentas/atividadesusuario/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.FERRAMENTAS_GESTAO_ATIVIDADES_MENU_2500700100],
    },
    goesToMenu: true,
  },
];
